import {
  Dialog,
  type DialogActionsProps,
  type DialogContentProps,
  type DialogProps,
  type DialogTitleProps,
} from '@mui/material';
import { color } from '@/colors';

export type { DialogActionsProps, DialogContentProps, DialogProps, DialogTitleProps };
export {
  DialogActions as AppDialogActions,
  DialogContent as AppDialogContent,
  DialogTitle as AppDialogTitle,
} from '@mui/material';

const dialogSx = {
  '& .MuiDialog-paper': {
    backgroundImage: 'none',
    borderRadius: '8px',
    border: `1px solid ${color.White08_T}`,
  },
};

export function AppDialog({ sx, ...props }: DialogProps) {
  return <Dialog sx={{ ...dialogSx, ...sx }} {...props} />;
}
